import React, {ReactNode} from 'react';
import { ScheduleButton, ButtonContainer } from './ButtonStyle';

interface ButtonExportProps {
  onClick: (e:any) => void;
  label: string;
  icon: ReactNode;
  htmlFor:string;
  disable: boolean;
}


const ButtonExport: React.FC<ButtonExportProps> = ({onClick, label, icon, htmlFor, disable}) => {

  return (
    <ButtonContainer aria-disabled={disable} onClick={onClick}>
        <ScheduleButton htmlFor={htmlFor} disable={disable}>
            {icon}
            <span>{label}</span>
        </ScheduleButton>
    </ButtonContainer>

  )

}

export default ButtonExport;
